module.exports = __webpack_public_path__ + "static/media/notFound.6ac3364a.png";